// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"650e9b15","3207":"81298bde","8855":"650e9b15"}[chunkId] + ".chunk.css";
};